// extracted by mini-css-extract-plugin
export default {"container":"ComunidadesHubs_container__bWK5V"};